
  // Shim Vue HMR runtime for dev-compiled components loaded by a non-Vite host.
  // When a remote is served by a Vite dev server, Vue's SFC compiler injects HMR
  // hooks that reference __VUE_HMR_RUNTIME__. This global only exists on pages
  // served by Vite's client runtime. When a production host loads the remote,
  // the HMR calls would throw. This no-op shim prevents that.
  if (typeof __VUE_HMR_RUNTIME__ === 'undefined') {
    globalThis.__VUE_HMR_RUNTIME__ = { createRecord() {}, rerender() {}, reload() {} };
  }
  import {init as runtimeInit, loadRemote} from "@module-federation/runtime";
  
  
const __mfResolveGlobalKey = "__mf_init__virtual:mf:__mfe_internal__experiences__mf_v__runtimeInit__mf_v__.js__";
let __mfResolveState = globalThis[__mfResolveGlobalKey];
if (!__mfResolveState) {
  let initResolve, initReject;
  const initPromise = new Promise((re, rj) => {
    initResolve = re;
    initReject = rj;
  });
  __mfResolveState = globalThis[__mfResolveGlobalKey] = {
    initPromise,
    initResolve,
    initReject,
  };
  if (typeof window === 'undefined') {
    initResolve({
      loadRemote: function() { return Promise.resolve(undefined); },
      loadShare: function() { return Promise.resolve(undefined); },
    });
  }
}
const initResolve = __mfResolveState.initResolve;

  
const __mfCacheGlobalKey = "__mf_module_cache__";
globalThis[__mfCacheGlobalKey] ||= { share: {}, remote: {} };
globalThis[__mfCacheGlobalKey].share ||= {};
globalThis[__mfCacheGlobalKey].remote ||= {};
const __mfModuleCache = globalThis[__mfCacheGlobalKey];

  const initTokens = {}
  const shareScopeName = "default"
  const mfName = "__mfe_internal__experiences"
  let localSharedImportMapPromise
  let exposesMapPromise
  const shouldRetrySharedInitError = false && ((error) => {
    const message = String((error && error.message) || error || '');
    return message.includes('Importing a module script failed') ||
      message.includes('Failed to fetch') ||
      message.includes('Load failed') ||
      message.includes('Outdated Optimize Dep');
  });
  const waitSharedInitRetry = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  async function retrySharedInit(fn) {
    for (let attempt = 0; ; attempt++) {
      try {
        return await fn();
      } catch (e) {
        const canRetry = typeof shouldRetrySharedInitError === 'function' && shouldRetrySharedInitError(e);
        if (!canRetry || attempt >= 19) throw e;
        await waitSharedInitRetry(250);
      }
    }
  }

  async function getLocalSharedImportMap() {
    if (!localSharedImportMapPromise) {
      localSharedImportMapPromise = retrySharedInit(() => import("virtual:mf-localSharedImportMap:__mfe_internal__experiences"))
        .catch((e) => { localSharedImportMapPromise = undefined; throw e; });
    }
    return localSharedImportMapPromise
  }

  async function getExposesMap() {
    if (!exposesMapPromise) {
      exposesMapPromise = retrySharedInit(() => import("virtual:mf-exposes:__mfe_internal__experiences__remoteEntry_js"))
        .then((mod) => mod.default ?? mod)
        .catch((e) => { exposesMapPromise = undefined; throw e; });
    }
    return exposesMapPromise
  }

  async function init(shared = {}, initScope = []) {
    const {usedShared, usedRemotes} = await getLocalSharedImportMap()
    if (__mfModuleCache.share["react"] === undefined) {
        const mod = await import("/home/github_actions/_work/experiences-web/experiences-web/node_modules/react/index.js");
        const __mfNormalizeRuntimeShare = (mod) => {
            let current = mod;
            for (let i = 0; i < 5; i++) {
              const defaultExport = current?.default;
              if (!defaultExport || typeof defaultExport !== "object") break;
              const namedValues = Object.keys(current).filter((key) => key !== "default").map((key) => current[key]);
              if (namedValues.length > 0 && namedValues.some((value) => value !== undefined)) break;
              current = defaultExport;
            }
            return current;
          };
        const normalizedModule = __mfNormalizeRuntimeShare(mod);
        const exportModule = normalizedModule === mod ? {...mod} : normalizedModule;
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react"] = exportModule;
      }
if (__mfModuleCache.share["react-dom"] === undefined) {
        const mod = await import("/home/github_actions/_work/experiences-web/experiences-web/node_modules/react-dom/index.js");
        const __mfNormalizeRuntimeShare = (mod) => {
            let current = mod;
            for (let i = 0; i < 5; i++) {
              const defaultExport = current?.default;
              if (!defaultExport || typeof defaultExport !== "object") break;
              const namedValues = Object.keys(current).filter((key) => key !== "default").map((key) => current[key]);
              if (namedValues.length > 0 && namedValues.some((value) => value !== undefined)) break;
              current = defaultExport;
            }
            return current;
          };
        const normalizedModule = __mfNormalizeRuntimeShare(mod);
        const exportModule = normalizedModule === mod ? {...mod} : normalizedModule;
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react-dom"] = exportModule;
      }
if (__mfModuleCache.share["@apollo/client"] === undefined) {
        const mod = await import("/home/github_actions/_work/experiences-web/experiences-web/node_modules/@apollo/client/index.js");
        const __mfNormalizeRuntimeShare = (mod) => {
            let current = mod;
            for (let i = 0; i < 5; i++) {
              const defaultExport = current?.default;
              if (!defaultExport || typeof defaultExport !== "object") break;
              const namedValues = Object.keys(current).filter((key) => key !== "default").map((key) => current[key]);
              if (namedValues.length > 0 && namedValues.some((value) => value !== undefined)) break;
              current = defaultExport;
            }
            return current;
          };
        const normalizedModule = __mfNormalizeRuntimeShare(mod);
        const exportModule = normalizedModule === mod ? {...mod} : normalizedModule;
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@apollo/client"] = exportModule;
      }
if (__mfModuleCache.share["@auth0/auth0-react"] === undefined) {
        const mod = await import("/home/github_actions/_work/experiences-web/experiences-web/node_modules/@auth0/auth0-react/dist/auth0-react.esm.js");
        const __mfNormalizeRuntimeShare = (mod) => {
            let current = mod;
            for (let i = 0; i < 5; i++) {
              const defaultExport = current?.default;
              if (!defaultExport || typeof defaultExport !== "object") break;
              const namedValues = Object.keys(current).filter((key) => key !== "default").map((key) => current[key]);
              if (namedValues.length > 0 && namedValues.some((value) => value !== undefined)) break;
              current = defaultExport;
            }
            return current;
          };
        const normalizedModule = __mfNormalizeRuntimeShare(mod);
        const exportModule = normalizedModule === mod ? {...mod} : normalizedModule;
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@auth0/auth0-react"] = exportModule;
      }
if (__mfModuleCache.share["react-router-dom"] === undefined) {
        const mod = await import("/home/github_actions/_work/experiences-web/experiences-web/node_modules/react-router-dom/dist/index.mjs");
        const __mfNormalizeRuntimeShare = (mod) => {
            let current = mod;
            for (let i = 0; i < 5; i++) {
              const defaultExport = current?.default;
              if (!defaultExport || typeof defaultExport !== "object") break;
              const namedValues = Object.keys(current).filter((key) => key !== "default").map((key) => current[key]);
              if (namedValues.length > 0 && namedValues.some((value) => value !== undefined)) break;
              current = defaultExport;
            }
            return current;
          };
        const normalizedModule = __mfNormalizeRuntimeShare(mod);
        const exportModule = normalizedModule === mod ? {...mod} : normalizedModule;
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react-router-dom"] = exportModule;
      }
if (__mfModuleCache.share["zustand"] === undefined) {
        const mod = await import("/home/github_actions/_work/experiences-web/experiences-web/node_modules/zustand/esm/index.mjs");
        const __mfNormalizeRuntimeShare = (mod) => {
            let current = mod;
            for (let i = 0; i < 5; i++) {
              const defaultExport = current?.default;
              if (!defaultExport || typeof defaultExport !== "object") break;
              const namedValues = Object.keys(current).filter((key) => key !== "default").map((key) => current[key]);
              if (namedValues.length > 0 && namedValues.some((value) => value !== undefined)) break;
              current = defaultExport;
            }
            return current;
          };
        const normalizedModule = __mfNormalizeRuntimeShare(mod);
        const exportModule = normalizedModule === mod ? {...mod} : normalizedModule;
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["zustand"] = exportModule;
      }
    const initRes = runtimeInit({
      name: mfName,
      remotes: usedRemotes,
      shared: usedShared,
      plugins: [],
      shareStrategy: 'version-first'
    });
    // handling circular init calls
    var initToken = initTokens[shareScopeName];
    if (!initToken)
      initToken = initTokens[shareScopeName] = { from: mfName };
    if (initScope.indexOf(initToken) >= 0) return;
    initScope.push(initToken);
    initRes.initShareScopeMap('default', shared);
    initResolve(initRes)
    try {
      await retrySharedInit(async () => {
        await Promise.all(await initRes.initializeSharing('default', {
          strategy: 'version-first',
          from: "build",
          initScope
        }));
      });
    } catch (e) {
      console.error('[Module Federation]', e)
    }
    for (const [pkg, share] of Object.entries(usedShared)) {
      if (share.shareConfig?.import !== false || __mfModuleCache.share[pkg] !== undefined) continue;
      const __mfNormalizeRuntimeShare = (mod) => {
            let current = mod;
            for (let i = 0; i < 5; i++) {
              const defaultExport = current?.default;
              if (!defaultExport || typeof defaultExport !== "object") break;
              const namedValues = Object.keys(current).filter((key) => key !== "default").map((key) => current[key]);
              if (namedValues.length > 0 && namedValues.some((value) => value !== undefined)) break;
              current = defaultExport;
            }
            return current;
          };
      const versions = shared?.[pkg];
      const provider = versions && versions[Object.keys(versions)[0]];
      if (!provider) continue;
      const factory = provider.lib || (provider.loading ? await provider.loading : await provider.get?.());
      const mod = typeof factory === "function" ? factory() : factory;
      const resolved = await Promise.resolve(mod);
      __mfModuleCache.share[pkg] = __mfNormalizeRuntimeShare(resolved);
    }
    return initRes
  }

  async function getExposes(moduleName) {
    const exposesMap = await getExposesMap()
    if (!(moduleName in exposesMap)) throw new Error(`[Module Federation] Module ${moduleName} does not exist in container.`)
    return (exposesMap[moduleName])().then(res => () => res)
  }
  export {
      init,
      getExposes as get
  }
  